import en from "./locales/en";
import tr from "./locales/tr";
import de from "./locales/de";
import fr from "./locales/fr";
import es from "./locales/es";
import pt from "./locales/pt";
import bg from "./locales/bg";
import nl from "./locales/nl";
import ja from "./locales/ja";
import ko from "./locales/ko";

export const SUPPORTED_LANGS = ["en", "tr", "de", "fr", "es", "pt", "bg", "nl", "ja", "ko"];

export const LANG_NAMES = {
  en: "English",
  tr: "Türkçe",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  pt: "Português",
  bg: "Български",
  nl: "Nederlands",
  ja: "日本語",
  ko: "한국어",
};

export const OG_LOCALES = {
  en: "en_US", tr: "tr_TR", de: "de_DE", fr: "fr_FR", es: "es_ES",
  pt: "pt_PT", bg: "bg_BG", nl: "nl_NL", ja: "ja_JP", ko: "ko_KR",
};

const dictionaries = { en, tr, de, fr, es, pt, bg, nl, ja, ko };

const isObj = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
const isDev = process.env.NODE_ENV === "development";

const merge = (base, override, lang, path) => {
  if (Array.isArray(base)) {
    if (!Array.isArray(override)) {
      if (isDev && override === undefined) console.warn(`[i18n] Missing key "${path}" in locale "${lang}" — falling back to English`);
      return base;
    }
    if (isDev && override.length !== base.length) console.warn(`[i18n] Array length mismatch at "${path}" in locale "${lang}"`);
    return base.map((item, i) => merge(item, override[i], lang, `${path}[${i}]`));
  }
  if (isObj(base)) {
    const out = {};
    for (const key of Object.keys(base)) {
      out[key] = merge(base[key], isObj(override) ? override[key] : undefined, lang, path ? `${path}.${key}` : key);
    }
    return out;
  }
  if (override === undefined) {
    if (isDev) console.warn(`[i18n] Missing key "${path}" in locale "${lang}" — falling back to English`);
    return base;
  }
  return override;
};

const cache = {};
export const getLocale = (lang) => {
  if (!cache[lang]) {
    cache[lang] = lang === "en" ? en : merge(en, dictionaries[lang] || {}, lang, "");
  }
  return cache[lang];
};
